<template>
  <v-form ref="simpleSearch">
    <v-row
      style="max-width: 1185px"
      class="mx-auto"
    >
      <v-col
        cols="12"
        md="3"
      >
        <v-select
          label="Acervo"
          dense
          :items="collections"
          :value="filter.idTipoPublicacao"
          @input="onPatchFilter({idTipoPublicacao: $event})"
          hide-details
          item-text="tipoPublicacao"
          item-value="idTipopublicacao"
          outlined
          clearable
          rounded
        ></v-select>
      </v-col>
      <v-col
        cols="12"
        md="2"
        v-if="isAdmin"
        class="text-center"
      >
        <v-checkbox
          dense
          hide-details
          class="mt-0"
          label="Privado"
          value="privado"
          @change="onPatchFilter({nivel: $event})"
        />
      </v-col>
      <v-col
        cols="12"
        md="7"
      >
        <v-text-field
          dense
          append-icon="fas fa-search accent--text"
          label="Encontre um registro no acervo"
          single-line
          outlined
          rounded
          :value="filter.where && filter.where.nome"
          @input="onPatchFilter({where: {
            nome: $event
          }})"
          @keyup.enter.native="onSearch({form: $refs.simpleSearch, $vuetify})"
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row
      style="max-width: 1185px"
      class="mx-auto"
    >
      <v-col
        cols="12"
        md="2"
      >
        <v-text-field
          v-mask="['##/##/####']"
          label="Data inicial *"
          placeholder="DD/MM/AAAA"
          :rules="[rules.date]"
          type="tel"
          outlined
          rounded
          dense
          hide-details
          :value="filter.initialDate"
          @input="onPatchFilter({initialDate: $event})"
        />
      </v-col>
      <v-col
        cols="12"
        md="2"
      >
        <v-text-field
          v-mask="['##/##/####']"
          label="Data final *"
          placeholder="DD/MM/AAAA"
          :rules="[rules.date]"
          type="tel"
          outlined
          rounded
          dense
          hide-details
          :value="filter.endDate"
          @input="onPatchFilter({endDate: $event})"
        />
      </v-col>
      <v-col
        cols="12"
        md="2"
      >
        <v-text-field
          dense
          placeholder="Localização"
          outlined
          rounded
          @input="onPatchFilter({localizacaoFisica: $event})"
          hide-details
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
      >
        <v-select
          :items="accounts"
          dense
          hide-details
          outlined
          clearable
          label="Colaboradores"
          item-text="name"
          item-value="id"
          rounded
          @input="onPatchFilter({idSubmissao: $event})"
        ></v-select>
      </v-col>
      <v-col
        cols="12"
        md="2"
        class="text-center"
      >
        <v-btn
          color="accent"
          rounded
          block
          @click="onSearch({form: $refs.simpleSearch, $vuetify})"
        >
          BUSCAR
        </v-btn>
      </v-col>
      <v-col
        cols="12"
        md="2"
        class="text-center"
      >
        <v-btn
          color="accent"
          text
          @click="onSearchTypeChange('advanced')"
        >
          BUSCA AVANÇADA
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import formRules from '@/mixins/form-rules';

export default {
  mixins: [formRules],
  props: {
    collections: {
      type: Array,
      default: () => [],
    },
    accounts: {
      type: Array,
      default: () => [],
    },
    filter: {
      type: Object,
      default: () => {},
    },
    search: {
      type: String,
      default: '',
    },
    onSearch: {
      type: Function,
      default: () => {},
    },
    onSearchTypeChange: {
      type: Function,
      default: () => {},
    },
    onPatchFilter: {
      type: Function,
      default: () => {},
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      menuInitial: false,
      menuEnd: false,
    };
  },
};
</script>
